import { parseDisplayPreference, parseTimeZone } from '@liquid-spirit/date-time/validation';

export const isDateTimePreferences = value => {
  try { parseDisplayPreference(value); return true; } catch { return false; }
};
export const isOptionalTimeZone = value => {
  if (value === undefined) return true;
  try { parseTimeZone(value); return true; } catch { return false; }
};
export class DateTimeMetadataRequestError extends Error {
  constructor() {
    super('Invalid community timezone fields: use agreeing named IANA zones and an object for settings.');
    this.name = 'DateTimeMetadataRequestError';
    this.code = 'INVALID_API_REQUEST';
  }
}
export function readCommunityTimeZoneRequest(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)
    || payload.settings !== undefined && (!payload.settings || typeof payload.settings !== 'object' || Array.isArray(payload.settings))
    || !isOptionalTimeZone(payload.timeZone)
    || !isOptionalTimeZone(payload.settings?.timezone)
    || payload.timeZone !== undefined && payload.settings?.timezone !== undefined && payload.timeZone !== payload.settings.timezone) {
    throw new DateTimeMetadataRequestError();
  }
  return payload;
}
